'use client';
import type {} from '@mui/material/themeCssVarsAugmentation';

import { AppRouterCacheProvider } from '@mui/material-nextjs/v15-appRouter';
import CssBaseline from '@mui/material/CssBaseline';
import { Experimental_CssVarsProvider as CssVarsProvider } from '@mui/material/styles';

import React from 'react';
import { createTheme } from './create-theme';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export function ThemeProvider({ children }: Props) {
  const theme = createTheme();

  return (
    <AppRouterCacheProvider options={{ key: 'cc', enableCssLayer: false }}>
      <CssVarsProvider
        theme={theme}
        defaultMode="light"
        disableTransitionOnChange={false}
        attribute="data-mui-color-scheme"
      >
        <CssBaseline />
        {children}
      </CssVarsProvider>
    </AppRouterCacheProvider>
  );
}
